export default "__VITE_ASSET__CkjDvb4L__"